import { BillDetailDto } from "./BillDetailDto";
import { BillInfoInvoiceDto } from "./BillInfoInvoiceDto";
import { PaymentDto } from "./PaymentDto";
import { VMProductInfoDto } from "./VMProductInfoDto";
/**
 * Bill object
 */
export class BillDto {
  hash: string;
  companyId: number;
  confirmBuy: string;
  billNumber: string;
  paymentType: number;
  transactionCode: string;
  machineCode: string;
  orderAmount: number;
  orderQuantity: number;
  orderPromoAmount?: number;
  orderParnerPromoAmount?: number;
  promotionId?: number;
  promoQuantity?: number;
  billDetailList: Array<BillDetailDto> = new Array<BillDetailDto>();
  paymentList: Array<PaymentDto> = new Array<PaymentDto>();
  paymentMethod: string;
  failRedirectUrl: string;
  successRedirectUrl: string;
  subOrderSource: string;
  orderUrl: string;
  notePO: string;
  ipAddress: string;
  memberId?: number;

  finalAmount: number;
  quantity: number;
  extraInfo: any;
  parentTransactionCodeRefund: string;
  state: string;

  // samling
  apiLinkSamling: string;
  isPartnerSamling: boolean;

  // voucher 
  amount: number; // là order amount hiện tại
  originAmount: number; // Giá trị đơn hàng ban đầu
  voucherAmount: number; // Giá trị voucher
  partyPayFee: string; // Đối tác chịu phí

  voucherSystem: string;
  ownerId?: number;
  ownerName?: string;
  vmOwnerType?: string;
  locationAreaMachineId?: number;
  localTime?: string;
  source?: string;
  sourceCode?: string;

  billDetails: Array<BillDetailDto> = new Array<BillDetailDto>(); // Dùng cho offline
  status: string;
  lastChangeData: Date;

  createType: string;
  voucherCode: string;

  productList: Array<VMProductInfoDto>;
  promotionIdList: Array<number>;

  isHasOutLayout: boolean;
  platformType: string;

  faceNumber: number;
  gender: string;
  ageRange: string;
  billInfoInvoice: BillInfoInvoiceDto
  vendingOrderId?: number
  checkingCode?: string
}

